import * as parentUtil from "../../../../util/util";
export const getLocalStorageValue = parentUtil.getLocalStorageValue